function clampUnit(t: number): number {
  return Math.max(0, Math.min(1, t));
}

/** Fast start, soft landing: shapes the tapered ends of a stroke. */
export function easeOutSine(t: number): number {
  return Math.sin((clampUnit(t) * Math.PI) / 2);
}

/** Slow-fast-slow: paces a pen drawing a stroke on. */
export function easeInOutSine(t: number): number {
  return -(Math.cos(Math.PI * clampUnit(t)) - 1) / 2;
}
